import { outboundExchangeKey, parcelTypes, parcelTypesByDirection } from '@/parcels/constants'

const parcelTypeByFilterValue = {
  [parcelTypes.outbound]: parcelTypes.outbound,
  [outboundExchangeKey]: parcelTypes.outbound,
  [parcelTypes.tracking]: parcelTypes.tracking,
}

const getIsExchangeParam = selectedTypes => {
  if (selectedTypes.includes(parcelTypes.tracking)) return null
  if (selectedTypes.includes(parcelTypes.outbound) && selectedTypes.includes(outboundExchangeKey)) return null
  if (selectedTypes.includes(outboundExchangeKey)) return true

  return false
}

export const getParcelRequestParams = (filters, direction) => {
  const { parcelType, ...restFilters } = filters

  if (!parcelType?.length) return { ...restFilters, type: parcelTypesByDirection[direction] }

  const type = [...new Set(parcelType.map(value => parcelTypeByFilterValue[value]))]
  const isExchange = getIsExchangeParam(parcelType)

  if (isExchange === null) return { ...restFilters, type }

  return { ...restFilters, type, is_exchange: isExchange }
}

export const getParcelsList = (parcels, t) => {
  if (!parcels?.length) {
    return ''
  }

  if (parcels.length === 1) {
    return parcels[0]
  }

  const lastParcel = parcels[parcels.length - 1]
  const restOfParcels = parcels.slice(0, parcels.length - 1)

  return `${restOfParcels.join(', ')} ${t('y')} ${lastParcel}`
}

export const getRelatedIds = (parcels, parcelIds) => {
  return parcels.filter(parcel => parcelIds.includes(parcel.id)).map(parcel => parcel.related.id)
}
